import { Fragment } from "react";
import { MenuItem, Select, SelectChangeEvent } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/pro-solid-svg-icons";
import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from "@emotion/react";
import { colors } from "../../styles/colors";
import {
  defaultLang,
  secondLang,
  defaultLangName,
  secondLangName,
} from "../../utils";

export const selectLangTheme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: colors.background_white,
          "&.Mui-focused": {
            outline: "1px solid #efbf07",
            backgroundColor: "white",
            border: "none",
          },
        },
        notchedOutline: {
          borderColor: colors.gray_white,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: colors.default_text,
          fontSize: "14px",
          fontFamily: "Inter,sans-serif",
          ":hover": {
            color: colors.default_highlight,
            backgroundColor: "white",
            "& .icon": {
              color: colors.default_highlight,
            },
          },
          "&.Mui-selected": {
            color: colors.default_highlight,
            backgroundColor: "white",
            "& .icon": {
              color: colors.default_highlight,
            },
            ":hover": {
              backgroundColor: "white",
            },
          },
        },
      },
    },
  },
});

const SelectLanguage: React.FC<{
  handleLangChange: (event: SelectChangeEvent) => void;
  lang: string;
}> = ({ handleLangChange, lang }) => {
  const getSelectedValue = (value: string) => {
    switch (value) {
      case secondLang.toUpperCase():
        return (
          <div className="text-sm flex items-center text-default-text">
            <FontAwesomeIcon
              className="text-ph-blue-lang-point w-2 h-2 pb-[2px] mr-2"
              icon={faCircle}
            />
            {secondLangName}
            <p className="text-xs  ml-1 text-[#414141DE]">
              ({secondLang.toUpperCase()})
            </p>
          </div>
        );
      case defaultLang.toUpperCase():
        return (
          <div className="text-sm flex items-center text-default-text">
            <FontAwesomeIcon
              className="text-default-highlight w-2 h-2 pb-[2px] mr-2"
              icon={faCircle}
            />
            {defaultLangName}
            <p className="text-xs  ml-1 text-[#414141DE]">
              {" "}
              ({defaultLang.toUpperCase()})
            </p>
          </div>
        );
      default:
        return "";
    }
  };
  return (
    <ThemeProvider theme={selectLangTheme}>
      <Fragment>
        <Select
          label="Choose Language"
          style={{ height: "46px" }}
          IconComponent={ExpandMoreIcon}
          value={lang}
          onChange={handleLangChange}
          sx={{
            width: "100%",
            border: "1px solid #eeecec",
            borderRadius: "4px",
            "& fieldset": { border: "none" },
            "@media (min-width: 960px)": {
              width: "48.5%",
            },
          }}
          renderValue={(selectedValue) =>
            getSelectedValue(selectedValue as string)
          }
        >
          <MenuItem value={secondLang.toUpperCase()}>
            <FontAwesomeIcon
              className="text-ph-blue-lang-point w-2 h-2 pb-[2px] mr-2 icon"
              icon={faCircle}
            />
            {secondLangName} ({secondLang.toUpperCase()})
          </MenuItem>
          <MenuItem value={defaultLang.toUpperCase()}>
            <FontAwesomeIcon
              className="text-default-highlight w-2 h-2 pb-[2px] mr-2"
              icon={faCircle}
            />
            {defaultLangName} ({defaultLang.toUpperCase()})
          </MenuItem>
        </Select>
      </Fragment>
    </ThemeProvider>
  );
};

export default SelectLanguage;
